import React from "react";
import loader from "../../assets/loader.gif"
import loaderBlue from "../../assets/loaderBlue.gif"
import { useTheme } from "../../context/ThemeContext";

const Loading = ({ height = "20px", width = "100%", margin = "0",isAnimation=false }) => {
    const {theme} = useTheme();
  return (
    <div className={`relative`} style={{ height, width, margin }}>
      {isAnimation ? <img className="w-[50px]" src={theme ==='light'? loaderBlue : loader} alt="logo"/> :<div className="animate-pulse absolute left-0 top-0 w-full h-full">
        <div className="h-full !flex w-full bg-gray-300 rounded w-full"></div>
      </div>}
    </div>
  );
};

export default Loading;
